var validationConstants = {
    ALPHA_NUMBERIC: "^(?:[a-z0-9\(\)\ \-]+|[a-z '-]+|[a-z0-9_.-]+@[^.][a-z0-9_.-]*\\.[a-z]+)$",
    EMAIL_PATTERN: '^[a-zA-Z0-9_.-]+@[^.][a-zA-Z0-9_.-]*\\.[a-zA-Z]+$',
    PHONE_NUMBER: '^\(?\d{3,3}\)?\s?\-?\d{2,3}\-?\d{2,}$',
    REGEXP_PHONE_NUMBER: /^\(?\d{3,3}\)?\s?\-?\d{2,3}\-?\d{2,}$/,
    VIN_NUMBER: '^[a-zA-Z0-9]+$',
    FIRST_NAME_MAX_LENGTH: 50,
    LAST_NAME_MAX_LENGTH: 50,
    EMAIL_MAX_LENGTH: 250,
    SEARCH_MAX_LENGTH: 128 //according to server limitation
};

module.exports = validationConstants;

